import {
    configDeviceList,
    getDeviceCommandId,
} from '../config/devicesList';
import { getDeviceById, resolveDeviceId } from '../config/legacyDeviceMigration';

export const deviceSelectId = 'gjs-device-select';

export const deviceChangeSelectCommand = (editor) => {
    editor.on('load', () => {
        const deviceSelect = document.getElementById(deviceSelectId);
        if (!deviceSelect) {
            return;
        }

        const setDeviceFromSelect = (deviceId) => {
            const device = getDeviceById(deviceId);
            const beforeDevice = editor.getDevice();
            if (device) {
                editor.setDevice(device.name);
            }
            const afterDirectSet = editor.getDevice();
            if (afterDirectSet === beforeDevice) {
                const command = getDeviceCommandId(deviceId);
                if (editor.Commands.has(command)) {
                    editor.runCommand(command);
                }
            }
        };

        setDeviceFromSelect(configDeviceList.default);

        deviceSelect.addEventListener('change', (event) => {
            const { value } = event.target;
            setDeviceFromSelect(value);
        });

        const syncSelectWithEditorDevice = () => {
            const editorDevice = editor.getDevice();
            const activeValue = resolveDeviceId(editorDevice);
            if (deviceSelect.value !== activeValue) {
                deviceSelect.value = activeValue;
            }
        };

        editor.on('change:device', syncSelectWithEditorDevice);
        editor.on('device:select', syncSelectWithEditorDevice);

        configDeviceList.devices.forEach((device) => {
            const command = getDeviceCommandId(device.id);
            editor.on(`run:${command}`, syncSelectWithEditorDevice);
        });
    });
};
